import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["materialsSummary", "variantSelect", "quantityInput"]

  connect() {
    this.updateMaterials()

    // Use MutationObserver to watch for DOM changes (Cocoon events don't work)
    this.observer = new MutationObserver((mutations) => {
      // Check if any nested-fields were added or removed, or if _destroy inputs changed
      const shouldUpdate = mutations.some(mutation => {
        // Check for added/removed nodes
        if (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0) {
          return true
        }
        // Check for changes to _destroy inputs
        if (mutation.type === 'attributes' && mutation.target.name && mutation.target.name.includes('_destroy')) {
          return true
        }
        return false
      })

      if (shouldUpdate) {
        this.updateMaterials()
      }
    })

    // Observe the batch-items container for changes
    const batchItemsContainer = this.element.querySelector('#batch-items')
    if (batchItemsContainer) {
      this.observer.observe(batchItemsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      })
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  updateMaterials() {
    // Add a small delay to ensure DOM is updated (especially for remove actions)
    setTimeout(() => {
      this.performUpdate()
    }, 100)
  }

  performUpdate() {
    // Collect all variant IDs and quantities
    const items = this.collectItems()

    if (items.length === 0) {
      this.showEmptyState()
      return
    }

    // Make AJAX request to calculate materials
    const params = new URLSearchParams()
    items.forEach((item, index) => {
      params.append(`items[${index}][variant_id]`, item.variantId)
      params.append(`items[${index}][quantity]`, item.quantity)
    })

    fetch(`/crafting/batch_logs/calculate_materials?${params.toString()}`, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      this.materialsSummaryTarget.innerHTML = html
    })
    .catch(error => {
      console.error('Error calculating materials:', error)
      this.showError()
    })
  }

  collectItems() {
    const items = []

    // Find all nested-fields that are not marked for destruction
    const nestedFields = this.element.querySelectorAll('.nested-fields')

    nestedFields.forEach(field => {
      // Skip if marked for destruction
      const destroyInput = field.querySelector('input[name*="_destroy"]')
      if (destroyInput && destroyInput.value === '1') {
        return
      }

      const variantSelect = field.querySelector('select[name*="[perfumed_candle_variant_id]"]')
      const quantityInput = field.querySelector('input[name*="[quantity]"]')

      if (variantSelect && quantityInput) {
        const variantId = variantSelect.value
        const quantity = parseInt(quantityInput.value) || 0

        if (variantId && quantity > 0) {
          items.push({ variantId, quantity })
        }
      }
    })

    return items
  }

  showEmptyState() {
    this.materialsSummaryTarget.innerHTML = `
      <div class="alert alert-info">
        Select candle variants and quantities above to see the materials required.
      </div>
    `
  }

  showError() {
    this.materialsSummaryTarget.innerHTML = `
      <div class="alert alert-danger">
        Error calculating materials. Please try again.
      </div>
    `
  }
}

